import { requestFirebaseNotificationPermission } from "../../../firebase/fcmService";
import {
  saveUserNotificationToken,
  userLogin,
} from "../../../helpers/backend_helper";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  loadingData,
} from "./reducer";

// loginUser thunk
export const loginUser = (user) => async (dispatch) => {
  try {
    dispatch(loadingData(true));

    const response = await userLogin({
      email: user.email,
      password: user.password,
    });

    if (response) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));

      const notificationResponse = await dispatch(saveNotificationToken());

      // if (notificationResponse) {
        window.location.href = "/dashboard";
      // }
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || "Login failed";
    console.log("Login Error:", errorMessage);
    dispatch(apiError(errorMessage));
  } finally {
    dispatch(loadingData(false));
  }
};

export const logoutUser = () => (dispatch) => {
  sessionStorage.removeItem("authUser");
  dispatch(logoutUserSuccess(true));
};

export const saveNotificationToken = () => async () => {
  try {
    const fcmToken = await requestFirebaseNotificationPermission();

    if (fcmToken) {
      await saveUserNotificationToken({
        fcm_token: fcmToken,
        device_type: "web",
      });
    } else {
      console.warn("Notification permission not granted. Skipping FCM registration.");
    }
  } catch (error) {
    console.warn("Notification error (ignored):", error?.message || error);
  }
};